import React, { Component } from "react";
import { connect } from "react-redux";
import ContentIcon, { HEADING_ATTENDEE } from "ContentIcon";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  fetchEvent,
  fetchEventSettings,
  showUserCountStatus,
  sortAttendeeListStatus,
} from "ActionsMessage";
import { COMMON_FAIL_MESSAGE, screenHeightLeftFromTop } from "Constants";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Attendee extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, desc: LocaleStrings.preparingAttendees };
  }

  componentDidMount() {
    this.props.fetchEvent(this.props.session, (callback) => {
      this.setState({ loading: false });
    });
    this.props.fetchEventSettings(this.props.session);
  }

  changeShowUserCountStatus = () => {
    var { session, eventData } = this.props;
    let status = 0;
    let message = LocaleStrings.attendee_networking_option_deactivated;
    if (eventData && eventData.shownetworkingusercount == 0) {
      status = 1;
      message = LocaleStrings.attendee_networking_option_activated;
    }

    this.props.showUserCountStatus(session, status, (response) => {
      if (response.success) {
        this.props.showSuccess(message);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  changeSortAttendeeListStatus = (e, flag) => {
    var { session, eventSettingsData } = this.props;

    let status = "az";
    let message = LocaleStrings.attendee_list_activated;
    if (flag) {
      status = "randomly";
      message = LocaleStrings.attendee_list_deactivated;
    }

    this.props.sortAttendeeListStatus(session, status, (response) => {
      if (response.success) {
        this.props.showSuccess(message);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  render() {
    var { deviceSize, eventData, eventSettingsData } = this.props;
    let showUserCountChecked = false;
    let sortAttendeeList = false;

    if (eventData && eventData.shownetworkingusercount == 1) {
      showUserCountChecked = true;
    }

    if (
      eventSettingsData &&
      eventSettingsData[0] &&
      eventSettingsData[0].attendeesort == "az"
    ) {
      sortAttendeeList = true;
    }

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_ATTENDEE} />
          </div>
        </div>
        <div className="clearfix"></div>
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <div className="row">
                <div className="col-md-9">
                  <div>
                    <div className="interest-title">
                      {LocaleStrings.attendee_interest_title}
                    </div>
                    <div className="interest-subtitle">
                      {LocaleStrings.attendee_interest_subtitle}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div style={{}}>
                    <label
                      className="poll-switch"
                      style={{ margin: "0 2%", marginTop: 5 }}
                    >
                      <input
                        type="checkbox"
                        onChange={this.changeShowUserCountStatus}
                        checked={showUserCountChecked}
                      />
                      <span className="poll-slider poll-round"></span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="clearfix"></div>
              <div className="h-divider-1"></div>
              <div className="clearfix"></div>

              {/* <div className="row">
            <div className="col-md-9">
              <div>
                <div className="interest-title">Sort Attendees List?</div>
                <div className="interest-subtitle">
                  Choose whether to display attendees list in alphabetically
                  sorted order.
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{}}>
                <label
                  className="poll-switch"
                  style={{ margin: "0 2%", marginTop: 5 }}
                >
                  <input
                    type="checkbox"
                    onChange={(e) =>
                      this.changeSortAttendeeListStatus(e, sortAttendeeList)
                    }
                    checked={sortAttendeeList}
                  />
                  <span className="poll-slider poll-round"></span>
                </label>
              </div>
            </div>
            </div> */}
              <div className="row">
                <div className="col-md-12 custom-text1-theme-medium">
                  {LocaleStrings.attendee_note}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    eventData: state.eventData[0],
    eventSettingsData: state.eventSettingsData,
  };
}
export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchEvent,
  fetchEventSettings,
  showUserCountStatus,
  sortAttendeeListStatus,
})(Attendee);
